<script setup lang="ts">
import { useSlots } from 'vue';

defineProps<{
  type: 'error' | 'alert';
}>();

const slots = useSlots();
const hasMessageSlot = () => Boolean(slots.message?.().length);
</script>

<template>
  <div :class="['warning-box', `type-${type}`]" data-tn="warning-box">
    <div class="warning-box__content">
      <div :class="['title', { 'no-message': !hasMessageSlot() }]">
        <slot name="title" />
      </div>

      <div v-if="hasMessageSlot()" class="message">
        <slot name="message" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.warning-box {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  border: 2px solid;
  border-radius: @border-radius-medium;
}

.warning-box__content {
  padding: 1rem;
  width: 100%;
  color: rgba(0, 0, 0, 0.85);

  .title {
    font-weight: @font-weight-bold;
    margin-bottom: 0.5rem;
    &.no-message {
      margin-bottom: 0;
    }
  }
}

.type-error {
  border-color: @color-warning;
  background-color: fade(@color-error, 20%);
}

.type-alert {
  border-color: @color-alert;
  background-color: @color-alert-background;
}
</style>
